export const NoInformation: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className,
  }: {
    className?: string;
  }) => {
    return (
      <svg
        width="88"
        height="88"
        viewBox="0 0 88 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M59.587 78.2919C69.9176 78.2919 78.2916 69.9178 78.2916 59.5872C78.2916 49.257 69.9176 40.8826 59.587 40.8826C49.2567 40.8826 40.8823 49.257 40.8823 59.5872C40.8823 69.9178 49.2567 78.2919 59.587 78.2919Z"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.5265 84.5268L72.813 72.8133"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0605 3.47327V59.5872"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.47314 19.0605V44"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.2349 3.47327V28.4128"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.6475 19.0605V37.7651"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  